<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="ABASTECIMENTOS ANALÍTICO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF"
             :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total" :titleReport="titleReport" :totalHide="true">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Empresa, Fornecedor, Carro, Motorista" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>                           
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell md-label="CÓDIGO" style="width: 10%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CARRO" style="width: 25%">{{ item.carro }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="MOTORISTA" style="width: 20%">{{ item.motorista }}</md-table-cell>
                        <md-table-cell v-if="item.id" class="uppercase" md-label="FORNECEDOR" style="width: 25%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell v-if="!item.id" class="uppercase" md-label="FORNECEDOR" style="width: 25%">
                            <strong>{{ item.fornecedor }}</strong>
                        </md-table-cell>
                        <md-table-cell v-if="item.id" md-label="DATA" style="width: 10%">{{ item.data_pagamento }}</md-table-cell>
                        <md-table-cell v-if="!item.id" md-label="DATA" style="width: 10%">
                             <strong>{{ item.data_pagamento }}</strong>
                        </md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>                        
                        <md-table-cell v-if="!item.id" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>                        
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify';
import Pagamento from '@/config/mixins/print/pagamento';
import getDateFormat from '@/config/mixins/getDateFormat';
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            titleReport: '',
            columnsPDF: [17, 40, 40, 40, 23, 25],
            headRowsPDF: ['CÓDIGO', 'CARRO', 'MOTORISTA', 'FORNECEDOR', 'DATA', 'VALOR'],
            bodyRowsPDF: ['id', 'carro', 'motorista', 'fornecedor', 'data_pagamento', 'valor'],          
            fildsTXT: ['id', 'empresa', 'carro', 'motorista', 'fornecedor', 'data_pagamento', 'valor_txt'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CARRO",
                    field: "carro",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "MOTORISTA",
                    field: "motorista",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DATA",
                    field: "data_pagamento"
                },
                {
                    label: "VALOR",
                    field: "valor_bd"
                },
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento, getDateFormat],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read() {
            let loader = this.openLoader('dots');
            this.titleReport = 'Relatório de abastecimento sintético - Período ' 
            + this.getDataInicial(this.buscar.dataInicial) + ' a ' + this.getDataFinal(this.buscar.dataFinal)
            this.$http.post(this.$urlAPI + 'abastecimentos/analitico', this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.carro, item.motorista, item.fornecedor, item.data_pagamento]).includes(this.toLower(term)))
            }
            return items
        }
    },

};
</script>
<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
